/* ============
 * Client Group Modal
 * ============
 *
 * This is the clientGroupModal
 */

import { mapGetters, mapMutations } from 'vuex';
import clientService from './../../services/client';
import clientGroupService from './../../services/client-group';
import subscriberService from './../../services/subscriber';
import store from './../../store';
import Forms from './../../utils/forms/forms';

export default {
  data() {
    return {
      form: new Forms({
        orgId: {
          value: '',
          type: 'text',
        },
      }),
      clients: [],
      selectedContact: [],
      groupName: 'Group Name',
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      subscriberList: 'subscriberList',
      subscriber: 'subscriber',
    }),
  },

  mounted() {
    store.dispatch('setCancelClientGroupAdd', false);
    this.fetchAllClientGroups();
  },

  watch: {
    //
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    save() {
      let tempData = [];
      this.selectedContact.forEach(function(item, key) {
        tempData.push({id:key, status: item});
      });
      store.dispatch('setchModifiedClientGroup', tempData);
      this.closeModal();
    },

    /**
     * Get group name.
     */
    fetchAllClientGroups() {
      this.loading = true;
      clientGroupService.all().then((groups) => {
        let self = this;
        groups.forEach(item => {
          if (item.id.toString() === self.subscriberList.currentClientGroup) {
            self.groupName = item.name;
            return;
          }
        });
        this.fetchAllSubscriber();
      });
    },

    /**
     * Get all subscriber.
     */
    fetchAllSubscriber() {
      Promise.all([
        subscriberService.all(this.$route.params.id),
      ]).then(() => {
        this.fetchClients();
      });
    },

    /**
     * Get clients.
     */
    fetchClients() {
      clientService.all().then((clients) => {
        let self = this;
        clients.forEach(item => {
          if (self.subscriberList.currentClientGroup === item.clientGroupId) {
            item.contacts.forEach(item2 => {
              self.subscriber.items.forEach(item3 => {
                if (item2.id === item3.contact_id) {
                  item2['exist'] = true;
                }
              });
            });
            self.clients.push(item);
          }
        });
        this.loading = false;
      });
    },

    /**
     * Closes the modal
     */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },

    cancel() {
      store.dispatch('setCancelClientGroupAdd', true);
      this.closeModal();
    },

  },
  components: {
    VForm: require('./../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/clientGroupModal/clientGroupModal.js